import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import ArticleListing from '../../reusable/Articles/ArticleListing';
import headerActions from '../../reusable/Header/Header.actions';
import api from './TrendingTerms.api';

class TrendingTermsListingPage extends Component {

    constructor(props) {
        super(props);

        this.filters = JSON.parse(props.routeParams.filters);
        this.term = JSON.parse(props.routeParams.term);
    }

    componentDidMount() {
        headerActions.updateHeaderContent(
            <FormattedMessage id='HeaderFooterNav_SubMenu_UIText_subMenu.trendingTerm'
                              values={{
                                  trendingTerm: <FormattedMessage id={"pguidTranslation_" + this.term.indexTermPGUID} />,
                                  daysNumber:   this.filters.noOfDays.toString()
                              }} />,
            'termsresultstips-field?lbu=US&locale=en_US&audience=all'
        );
    }

    render() {
        return <div className="trending-terms-page">
            <ArticleListing url={`/api/articles/indexTerm/${this.term.indexTermPGUID}`}
                            countUrl={`/api/articles/count/indexTerm/${this.term.indexTermPGUID}`}
                            urlParams={this.filters}
                            api={api}
                            filters={{ indexTerm: this.term.indexTermPGUID }}
                            helpUrl={'termsresultstips-field?lbu=US&locale=en_US&audience=all'} />
        </div>
    }
}

export default TrendingTermsListingPage;


// WEBPACK FOOTER //
// ./src/scripts/pages/TrendingTerms/TrendingTermsListingPage.jsx